const useMenuItems = () => {
    const links = [{ name: "home", slug: "/" }, { name: 'collection', slug: '/collections' }, { name: "studio", slug: "/studio/" }, { name: "contact" }]
    return links
}

export default useMenuItems